import React from "react";
import { IPlayerDataProps, IPlayerCardDetail } from "../../../types/IPlayerCardDetail";
import PlayerLandingCard from "../../../ui/CardComponent";
import { useNotification } from "../../../contexts/NotificationContext";
import PWNotification from "../../PWNotification";

const SquadPlayerData: React.FC<IPlayerDataProps> = ({ roles, players }) => {
  const { displayCardNotification, seIsDisplayCardNotification, cardNotificationContent, setCardNotificationContent } = useNotification();
  return (
    <>
      <div className="players">
        {players?.map((player: IPlayerCardDetail, playerIndex: number) => (
          <PlayerLandingCard
            key={playerIndex}
            playerId={player.playerId}
            givenName={player.givenName}
            familyname={player.familyname}
            playerImageURL={player.playerImageURL}
            isInjured={player.isInjured}
            onLoan={player.onLoan}
            givenOnLoan={player.givenOnLoan}
            primaryPlayingPosition={player.primaryPlayingPosition}
            age={player.age}
            heightInCM={player.heightInCm}
            playerAttributesByPosition={player.playerAttributesByPosition}
            contributionValue={player.contributionValue}
            performanceValue={player.performanceValue}
            isRemoveAvailable={false}
            isPlayerInShortlist={player.isPlayerInShortlist}
            isEasternPlayer={player?.isEasternPlayer}
            playerLabel={player?.playerLabel}
            archetypeName={player?.archetypes?.[0]?.archetypeName}
            archetypeId={player?.archetypes?.[0]?.id}
          />
        ))}
      </div>
      {displayCardNotification && (
        <PWNotification
          message={cardNotificationContent}
          setIsNotification={() => seIsDisplayCardNotification(false)}
          isDisplayCloseIcon={true}
          className="player-filter-notification add-similar-notification"
        />
      )}
    </>
  );
};

export default SquadPlayerData;
